import { render } from "./VendorChatbot.vue?vue&type=template&id=5416ab0a&scoped=true"
import script from "./VendorChatbot.vue?vue&type=script&lang=js"
export * from "./VendorChatbot.vue?vue&type=script&lang=js"

import "./VendorChatbot.vue?vue&type=style&index=0&id=5416ab0a&scoped=true&lang=css"

import exportComponent from "E:\\DeepakKumarJha\\TfsProjects\\BrikTok\\BrikTokApi\\BrikTokAdminPortal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5416ab0a"]])

export default __exports__